import Client from '@/app/repository/axios-client';

export default {
  getCoreReleaseInfo() {
    return Client.get('/release-info');
  }
};
